import { render, staticRenderFns } from "./EnterOtp.vue?vue&type=template&id=535e5a14&"
import script from "./EnterOtp.vue?vue&type=script&lang=js&"
export * from "./EnterOtp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('535e5a14')) {
      api.createRecord('535e5a14', component.options)
    } else {
      api.reload('535e5a14', component.options)
    }
    module.hot.accept("./EnterOtp.vue?vue&type=template&id=535e5a14&", function () {
      api.rerender('535e5a14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/payasguest/screens/PayAsGuest/EnterOtp.vue"
export default component.exports